/**
 * 码管理模块路由
 * topNav: code
 */
export default {
  path: 'code',
  name: 'Code',
  component: () => import('@/layout/RouteView.vue'),
  meta: { title: '码管理', titleKey: 'routes.code', topNav: 'code', icon: 'QrcodeOutlined' },
  children: [
    // 码管理（分组）
    {
      path: 'code-management',
      name: 'CodeManagement',
      component: () => import('@/layout/RouteView.vue'),
      meta: { title: '码管理', titleKey: 'routes.codeManagement', icon: 'QrcodeOutlined' },
      children: [
        {
          path: 'batch-list',
          name: 'CodeBatchList',
          component: () => import('@/views/code/code-management/batch-list.vue'),
          meta: { title: '码批次列表', titleKey: 'routes.codeBatchList' },
        },
        // 码批次 — 按钮级权限
        {
          path: 'batch-list',
          name: 'CodeBatchListUpdate',
          component: () => import('@/layout/RouteView.vue'),
          meta: { title: '编辑备注', permission: 'codeBatch:update', hidden: true },
        },
        {
          path: 'status-control',
          name: 'CodeStatusControl',
          component: () => import('@/views/code/code-management/status-control.vue'),
          meta: { title: '码状态控制', titleKey: 'routes.codeStatusControl' },
        },
        // 码禁用 — 按钮级权限
        {
          path: 'status-control',
          name: 'CodeDisableCreate',
          component: () => import('@/layout/RouteView.vue'),
          meta: { title: '添加禁用', permission: 'codeDisable:create', hidden: true },
        },
        {
          path: 'status-control',
          name: 'CodeDisableUpdate',
          component: () => import('@/layout/RouteView.vue'),
          meta: { title: '编辑禁用', permission: 'codeDisable:update', hidden: true },
        },
        {
          path: 'status-control',
          name: 'CodeDisableRelease',
          component: () => import('@/layout/RouteView.vue'),
          meta: { title: '解除禁用', permission: 'codeDisable:release', hidden: true },
        },
        {
          path: 'product-assign',
          name: 'ProductCodeAssignment',
          component: () => import('@/views/code/code-management/product-assign.vue'),
          meta: { title: '产品赋码', titleKey: 'routes.productCodeAssignment' },
        },
        // 产品赋码 — 按钮级权限
        {
          path: 'product-assign',
          name: 'ProductCodeAssignmentCreate',
          component: () => import('@/layout/RouteView.vue'),
          meta: { title: '添加赋码', permission: 'productAssign:create', hidden: true },
        },
        {
          path: 'product-assign',
          name: 'ProductCodeAssignmentDelete',
          component: () => import('@/layout/RouteView.vue'),
          meta: { title: '删除赋码', permission: 'productAssign:delete', hidden: true },
        },
      ],
    },
    // 防伪溯源（分组）
    {
      path: 'anti-fake',
      name: 'AntiFakeTrace',
      component: () => import('@/layout/RouteView.vue'),
      meta: { title: '防伪溯源', titleKey: 'routes.antiFakeTrace', icon: 'SafetyOutlined' },
      children: [
        {
          path: 'scan-template',
          name: 'ScanTemplate',
          component: () => import('@/views/code/anti-fake/scan-template/index.vue'),
          meta: { title: '扫码模板', titleKey: 'routes.scanTemplate' },
        },
        {
          path: 'scan-template/editor/:templateId?',
          name: 'ScanTemplateEditor',
          component: () => import('@/views/code/anti-fake/scan-template/editor.vue'),
          meta: {
            title: '模板编辑器',
            titleKey: 'routes.scanTemplateEditor',
            hidden: true,
            contentPlain: true,
            contentFull: true,
          },
        },
        {
          path: 'product-link',
          name: 'ProductLinkTemplate',
          component: () => import('@/views/code/anti-fake/product-link.vue'),
          meta: { title: '产品关联模板', titleKey: 'routes.productLinkTemplate' },
        },
        // 产品关联模板 — 按钮级权限
        {
          path: 'product-link',
          name: 'ProductLinkTemplateUpdate',
          component: () => import('@/layout/RouteView.vue'),
          meta: { title: '修改模板', permission: 'productLink:update', hidden: true },
        },
        {
          path: 'scan-detail',
          name: 'ScanDetail',
          component: () => import('@/views/code/anti-fake/scan-detail.vue'),
          meta: { title: '扫码明细', titleKey: 'routes.scanDetail', permission: 'scanDetail:view' },
        },
        // 扫码明细 — 按钮级权限
        {
          path: 'scan-detail',
          name: 'ScanDetailExport',
          component: () => import('@/layout/RouteView.vue'),
          meta: { title: '导出扫码明细', permission: 'scanDetail:export', hidden: true },
        },
        {
          path: 'alert-record',
          name: 'AlertRecord',
          component: () => import('@/views/code/anti-fake/alert-record.vue'),
          meta: {
            title: '预警记录',
            titleKey: 'routes.alertRecord',
            permission: 'alertRecord:view',
          },
        },
        // 预警记录 — 按钮级权限
        {
          path: 'alert-record',
          name: 'AlertRecordExport',
          component: () => import('@/layout/RouteView.vue'),
          meta: { title: '导出预警记录', permission: 'alertRecord:export', hidden: true },
        },
        {
          path: 'alert-record',
          name: 'AlertRecordResolve',
          component: () => import('@/layout/RouteView.vue'),
          meta: { title: '解除预警', permission: 'alertRecord:resolve', hidden: true },
        },
        {
          path: 'alert-record',
          name: 'AlertRecordDisable',
          component: () => import('@/layout/RouteView.vue'),
          meta: { title: '禁用二维码', permission: 'alertRecord:disable', hidden: true },
        },
        {
          path: 'alert-setting',
          name: 'AlertSetting',
          component: () => import('@/views/code/anti-fake/alert-setting.vue'),
          meta: {
            title: '预警设置',
            titleKey: 'routes.alertSetting',
            permission: 'alertSetting:view',
          },
        },
        // 预警设置 — 按钮级权限
        {
          path: 'alert-setting',
          name: 'AlertSettingUpdate',
          component: () => import('@/layout/RouteView.vue'),
          meta: { title: '保存预警设置', permission: 'alertSetting:update', hidden: true },
        },
      ],
    },
  ],
};
